// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1___2594259cdd00c86615a","cls2":"SmallAccountMenuButton-cls2__e29f43266e88dd6549c3 SmallAccountMenuButton-cls1___2594259cdd00c86615a"};